module.exports = __webpack_public_path__ + "static/img/home_icon1.e6c536ab.png";